/*==============================
importe { _Permissions } en el archivo .vue y agreguelo como un mixin y utilice el método CheckPermision() dentro del componente;
El método CheckPermision como parámetro se le envía uno de los siguientes valores:
 - standar_forms
 - multi_forms
 - sub_forms
 - view_responses
 - data_origin
 - forms_with_ml
 - form_validator
 - notifications
 - serviforms_connect
 - serviforms_app
 - filter_and_export
 - private_apps
 - showcase
 - bot_forms
 - dispatcher_uri
 - visits
*/

import store from '@/store';
import permitions from './permitions.json'

const permissions = class Permissions {
    constructor(isInit = false) {
        if(typeof Permissions.instance === "object" && !isInit) {
            return Permissions.instance;
        }
        
        this.permissions = store.state.user.features;
        Permissions.instance = this;
        return this;
    }   

    check(permission) {
        return this.permissions.includes(permission);
    }

    checkCrud(rol, permition) {
        return permitions[rol.toLowerCase()].includes(permition)
    }

}

const _Permissions = {
    data() {
        return {
            Permissions: new permissions(),
        }
    },
    methods: {
        CheckPermision(permision) {
            return this.Permissions.check(permision);
        },
        checkCrud(rol, permition) {
            return this.Permissions.checkCrud(rol, permition)
        }
    },
}

export { permissions, _Permissions };